// Import any necessary action types
// import { SET_USER, UPDATE_USER, DELETE_USER } from '../actions/types';

// Define the initial state
const initialState = {
    magasin: null,
};

const magasinReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_MAGASIN":
            return {
                ...state,
                magasin: {
                    ID: action.payload.ID,
                    Nom: action.payload.Nom
                }
            };
        default:
            return state;
    }
};

export default magasinReducer;